export function headerinfo() {
  this.fFieldList = null;
  this.fErrorMsg = null;
}
